let counter = 1;
// eslint-disable-next-line no-plusplus
export const uniqueId = (...prefixes) => prefixes.map((p) => `${p}-${counter++}`);
